import { gql } from '@apollo/client';

const deleteCountry = gql`
  mutation deleteCountry($id: Int!) {
    deleteCountry(id: $id)
  }
`;

export default deleteCountry;
